package feature.productSubCategory.event

class ProductSubCategoryEvent {
    companion object {
        const val CREATE = "CREATE_PRODUCT_SUB_CATEGORY"
        const val UPDATE = "UPDATE_PRODUCT_SUB_CATEGORY"
        const val UPDATE_IMAGE = "UPDATE_PRODUCT_SUB_CATEGORY_IMAGE"
        const val RETRIEVE = "RETRIEVE_PRODUCT_SUB_CATEGORY"
        const val DELETE = "DELETE_PRODUCT_SUB_CATEGORY"
    }
}